export default "__VITE_ASSET__DXR8pX0___"